import { Injectable } from '@angular/core';
import { HttpClientProtectedService } from '@core/services/auth/http-client-protected.service';
import { Rotas } from '@core/enums/routes';
import { DadosMapaQuantis } from '../interfaces/mapa-quantis-mensal';
import { RespostaGraficoVariaveis } from '../interfaces/VariaveisMeteorologicas';
import { Iapm } from '../interfaces/iapm';
import { IapmDTO } from '../interfaces';

@Injectable({
	providedIn: 'root',
})
export class GraficosPrecipitacaoService {
	gerarGraficoIAPM(
		id: number | string | undefined,
		agrupamento: string,
		periodo: string,
		dataInicial: string,
		dataFinal: string
	) {
		return this.http.get<IapmDTO[]>(Rotas.GRAFICOS + '/grafico-iapm', {
			id,
			agrupamento,
			periodo,
			dataInicial,
			dataFinal,
		});
	}
	constructor(private http: HttpClientProtectedService) {}

	buscarMapaQuantisMensal(
		regioesIds: number[],
		diaInicio: string | null,
		diaFim: string
	) {
		return this.http.post<any, DadosMapaQuantis[]>(
			Rotas.GRAFICOS + `/precipitacao/mapas-quantis-mensal`,
			{
				regioesIds,
				diaInicio,
				diaFim,
			}
		);
	}

	buscarGraficoVariaveisMetereologicas(
		postoId: number,
		diaInicio: string | null,
		diaFim: string
	) {
		return this.http.post<any, RespostaGraficoVariaveis>(
			Rotas.GRAFICOS + `/variavel`,
			{
				postoId,
				diaInicio,
				diaFim,
			}
		);
	}

	buscarIAPM(dataInicial: string | null, dataFinal: string) {
		return this.http.get<Iapm[]>(
			Rotas.GRAFICOS + `/mrai?dataInicial=${dataInicial}&dataFinal=${dataFinal}`
		);
	}
}
